import React from "react";

const acceptedLinksRegex = {
    loom: /loom\.com\/share\/(?<id>[^\/]+)/,
    youtube: /youtube.com\/watch\/?\?v=(?<id>[^\&]+)/,
}

export const getEmbedURL = (src) => {
    const [, group] = videoRegex.exec(src) ?? [];
    const id = acceptedLinksRegex[group]?.exec(src)?.groups?.id;
    if (!id) return null;

    return `//www.${group}.com/embed/${id}`
}

export const videoRegex = /^http.*\.(youtube|loom).com/;


const IframeVideo = React.memo(({ src, }) => {
    src = getEmbedURL(src);

    if (src === null) {
        return null;
    }

    return (
        <div className="contained-width" style={{ position: "relative", paddingBottom: "56%", height: "0" }}>
            <iframe src={src}
                frameBorder="0"
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                allowFullScreen
                style={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%",}}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                />
        </div>
    )
})

export default IframeVideo